import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../lib/api';

const PeriodContext = createContext(null);

export function PeriodProvider({ children }) {
  const [periods, setPeriods]         = useState([]);
  const [activePeriod, setActivePeriod] = useState(null);

  const fetchPeriods = async () => {
    try {
      const res = await API.get('/periods');
      const data = res.data || [];
      setPeriods(data);
      if (!activePeriod && data.length > 0) {
        // Default to most recent period that has data (ACTIVE/STAGED), then OPEN
        const active = data.find(p => ['ACTIVE','STAGED','PROMOTED'].includes(p.status));
        const open   = data.find(p => p.status === 'OPEN');
        setActivePeriod(active || open || data[0]);
      }
    } catch (e) {
      console.error('Failed to fetch periods', e);
    }
  };

  useEffect(() => { fetchPeriods(); }, []);

  return (
    <PeriodContext.Provider value={{ periods, activePeriod, setActivePeriod, fetchPeriods }}>
      {children}
    </PeriodContext.Provider>
  );
}

export const usePeriod = () => useContext(PeriodContext);
